/// //////////////////////////////////////////////////////////////////////////
//                                                                          //
//  本文件由WIDE自动生成框架，用来定义类似webcomponent的元素．                     //
//  本文件用于引入元素类的依赖环境。                                             //
//                                                                          //
//  WIDE website: http://www.wware.org/                                     //
/// //////////////////////////////////////////////////////////////////////////
// Created At : 2019-02-22T13:11:40.666Z

'use strict'

import Wwcompiler from './commands'

// 封装在wwimport，以防止在wwjs加载完成之前加载．通常是不必要的．
wwimport('ready', () => {
  function proc () {
    console.log('reg')
    wwjs.net.reg(`@/@wwcmd/wwcompiler/${Wwcompiler.version()}/wwcompiler.min.js`, Wwcompiler)
    wwjs.net.reg(`@@wwcompiler`, Wwcompiler)
  }

  // 如果没有任何异步资源需要加载，则使用下方代码。
  // proc()

  //* //如果有需要异步加载的依赖库，则使用下方代码。
  const depArray = wwjs.loadjs.resolve([ '@/underscore/1.9.1/underscore-min.js',
    '@/underscore.string/3.3.5/underscore.string.min.js'
  ])
  window.wwjs.loadjs.load(depArray, {
    success: function () {
      // 依赖加载检查，如果依赖库加载完毕的检查是异步的，我们通过定时器来检查是否以来完毕。如果依赖加载完毕，则开始正常注册。
      proc()
    },
    error: function (pathsNotFound) {
      console.error(`依赖加载错误:${pathsNotFound}`)
    }
  })
  // */
})
